// extracted by mini-css-extract-plugin
module.exports = {"footnote":"BundlePricingPageSegment-Footnote-module--footnote--XHMWE"};